import { Table as AntdTable, type TableProps as AntdTableProps } from 'antd';
import type { ReactNode, VFC } from 'react';
import { SkeletonTable, type SkeletonTableColumnsType } from '../loading_skeletons/Table';

export interface TableProps<T> extends AntdTableProps<T> {
  /**
   * Rendered as a sibling right after the table, before any bulk-actions consumer wires its own
   * sticky/positioning around it - matches enmon-frontend's Table `bulkActions` prop shape.
   */
  bulkActions?: ReactNode;
}

export function Table<T extends Record<string, any>>(props: TableProps<T>): ReturnType<VFC<TableProps<T>>> {
  const { loading, pagination, columns, bulkActions, ...restProps } = props;

  return (
    <>
      {loading ? (
        <SkeletonTable
          columns={columns as SkeletonTableColumnsType[]}
          rowCount={pagination ? pagination?.pageSize : 10}
        />
      ) : (
        <>
          <AntdTable {...restProps} columns={columns} loading={loading} pagination={pagination} />
          {bulkActions}
        </>
      )}
    </>
  );
}
